<template>
  <v-combobox
    v-model="model"
    class="form_style select_box combo_box"
    :items="items"
    :placeholder="placeholder"
    item-title="label"
    item-value="value"
    multiple
    clearable
    :menu-props="{ contentClass: 'combobox_overlay' }"
  />
</template>

<script setup lang="ts">
/** components */
import { Base } from "../BaseFactory";

/** model */
const model = defineModel<any[]>({
  default: () => [],
});

/** props */
defineProps({
  placeholder: {
    type: String,
    default: "",
  },
  items: {
    type: Array,
    default: () => [],
  },
});
</script>
